<template>
    <div
        :class="[
            'bo-table-div table-v2',
            {
                'is-collapsible': hasSubrecord,
            },
        ]"
    >
        <!-- Title & Column Sorting -->
        <slot
            name="header"
            :title="title"
            :compact="compactView"
            :expanded="visible"
            :displayHeaderFilters="displayHeaderFilters"
            :allHeadersSelected="allHeadersSelected"
            :columns="columns"
            :toggleVisibility="changeTableVisibility"
            :toggleCompact="changeCompactView"
            :toggleHeaderFiltersVisibility="toggleHeaderFiltersVisibility"
            :hideHeaderFilters="hideHeaderFilters"
            :setAllHeaders="setAllHeaders"
            :resetHeadersToDefault="resetHeadersToDefault"
            :changeTitle="changeTitle"
            :changeColumns="changeColumns"
        >
            <div
                class="table-header bo-table-header"
                v-if="displayTitleHeader"
                :class="{
                    'hide-header': !showHeader,
                    'form-table-header': isForm,
                    'has-selected-records': selectedRecordsCount > 0,
                }"
            >
                <div class="left-panel">
                    <div class="left-panel-wrapper">
                        <div
                            v-if="isCollapsible"
                            class="indicator cursor-pointer"
                            :class="{ collapsed: !visible }"
                            @click="changeTableVisibility"
                        >
                            <i class="icon icon-expandmore"></i>
                        </div>
                        <div class="d-flex align-items-center">
                            <span
                                v-if="
                                    ((!enableUpdateRecord && !enableViewSelectedRecords) ||
                                        ((enableUpdateRecord || enableViewSelectedRecords) &&
                                            0 == selectedRecordsCount)) &&
                                    title
                                "
                                class="title"
                            >
                                {{ title }}
                            </span>
                            <div
                                v-if="enableViewSelectedRecords && selectedRecordsCount"
                                class="d-flex align-items-center"
                            >
                                <span class="title">{{ selectedRecordsCount }} Selected</span>
                                <i
                                    class="icon-close cursor-pointer clear-selection pr-3"
                                    style="display: inline-block"
                                    @click="clearSelection"
                                ></i>
                            </div>
                            <div
                                v-if="enableUpdateRecord && selectedRecordsCount"
                                class="d-flex align-items-center"
                            >
                                <span class="title">{{ selectedRecordsCount }} Selected</span>
                                <i
                                    class="icon-close cursor-pointer clear-selection pr-3"
                                    style="display: inline-block"
                                    @click="clearSelection"
                                ></i>
                                <button
                                    v-if="enableUpdateRecord"
                                    @click="updatedSelectedRecords"
                                    class="btn btn-rounded arclight"
                                >
                                    <slot name="update_button_text"><span>Update</span></slot>
                                </button>
                            </div>

                            <!-- <bo-add-product
                            v-if="addProduct"
                            :advanceSearchColumns="advanceSearchColumns"
                            :advanceSearchProductUrl="advanceSearchProductUrl"
                            :advanceSearchProductOptionsUrl="advanceSearchProductOptionsUrl"
                            v-on:addProducts="addProducts"
                        ></bo-add-product> -->
                        </div>
                        <slot name="left_header_buttons"></slot>
                    </div>
                </div>

                <div class="right-panel" v-show="visible">
                    <div
                        class="btn-rounded danger clear-selection clear-items-button"
                        v-if="editable && deleteMultiple && showClearItemButton && (showClearItemWhenDisabled || selectedRecordsCount > 0)"
                        :class="{ disabled: !selectedRecordsCount }"
                        @click="selectedRecordsCount ? deleteSelectedRecords() : null"
                    >
                        <i class="icon-deleteforever"></i>
                        <span>{{
                            Object.keys(generalTranslations).length === 0
                                ? "Clear Item"
                                : generalTranslations?.clear_object?.replace(
                                      ":object",
                                      generalTranslations?.item ?? "Item"
                                  ) ?? "Clear Item"
                        }}</span>
                    </div>
                    <!-- All of these should be a slot -->
                    <!-- <div v-if="importRecordsUrl" id="btn-import" class="btn-rounded transparent arclight">
                        <label for="file-import" class="m-0 cursor-pointer d-flex align-items-center">
                            <i class="icon-getapp text-20"></i>
                            <span>Import</span>
                        </label>
                        <input
                            class="hide"
                            id="file-import"
                            type="file"
                            name="file_import"
                            accept=".xls, .xlsx"
                            @change="importRecords"
                        />
                    </div> -->

                    <!-- <button
                        v-if="downloadTemplateUrl"
                        id="btn-import"
                        class="btn-rounded transparent arclight"
                        @click="downloadTemplate"
                    >
                        <i class="icon-clouddownload"></i>
                        <span>Download Template</span>
                    </button> -->

                    <template v-if="printUrl">
                        <!-- <div class="btn-rounded transparent arclight" @click="printShowPopup = true">
                            <i class="icon-share"></i>
                            <span>Print</span>
                        </div>

                        <div class="dropdown-menu dropdown-menu-right" v-if="printShowPopup" style="display: block;"
                            v-click-outside="hidePrintPopup">
                            <a class="dropdown-item" href="#" @click="printRecords('document')">Document</a>
                            <a class="dropdown-item" href="#" @click="printRecords('pick-list')"> Pick List </a>
                        </div> -->

                        <div class="dropdown">
                            <button
                                class="btn-rounded transparent arclight"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i class="icon-share"></i>
                                <span>Print</span>
                            </button>
                            <div
                                class="dropdown-menu dropdown-menu-right"
                                aria-labelledby="dropdownMenuButton"
                            >
                                <a
                                    class="dropdown-item"
                                    href="#"
                                    @click="printRecords('document')"
                                    >Document</a
                                >
                                <a
                                    class="dropdown-item"
                                    href="#"
                                    @click="printRecords('pick-list')"
                                >
                                    Pick List
                                </a>
                            </div>
                        </div>
                    </template>

                    <!-- <template v-if="exportUrl">
                        <div class="btn-rounded transparent arclight" @click="exportShowPopup = true">
                            <i class="icon-share"></i>
                            <span>Export</span>
                        </div>

                        <div
                            class="dropdown-menu dropdown-menu-right"
                            style="display: block; top: auto; right: auto"
                            v-if="exportShowPopup"
                            v-click-outside="hideExportPopup"
                        >
                            <a class="dropdown-item" href="#" @click="exportRecords('partial')">
                                Export Selected CSV File
                            </a>

                            <a class="dropdown-item" href="#" @click="exportRecords('all')"> Export All CSV File </a>
                        </div>
                    </template> -->
                    <slot name="right_header_buttons"></slot>
                    <div
                        class="column-filter"
                        :hidden="hideDisplayHeaderFilter"
                    >
                        <button
                            type="button"
                            class="btn-rounded bordered primary light dropdown-toggle"
                            aria-haspopup="true"
                            aria-expanded="false"
                            @click="toggleHeaderFiltersVisibility"
                        >
                            <i class="icon-columnlist"></i>
                        </button>

                        <!-- COLUMN SORTING -->
                        <div
                            class="dropdown-menu dropdown-menu-right"
                            style="display: block"
                            v-if="displayHeaderFilters"
                            v-click-outside="hideHeaderFilters"
                        >
                            <div class="column-sorting">
                                <div class="column-header column">
                                    <input
                                        type="checkbox"
                                        v-model="allHeadersSelected"
                                        :id="datatableUniqueKey + '_header_checkbox'"
                                        @change="setAllHeaders"
                                    />
                                    <span>{{ generalTranslations?.column_headers ?? "Column Header" }}</span>
                                </div>
                                <draggable
                                    v-model="columnSequence"
                                    v-bind="dragOptions"
                                    handle=".icon-dragindicator"
                                    @start="drag = true"
                                    @end="drag = false"
                                >
                                    <transition-group
                                        type="transition"
                                        :name="!drag ? 'flip-list' : null"
                                    >
                                        <template v-for="header in columnSequence">
                                            <div
                                                class="column"
                                                :key="header.id"
                                            >
                                                <template v-if="!header.disabled">
                                                    <i class="icon-dragindicator"></i>
                                                    <input
                                                        v-model="header.visible"
                                                        type="checkbox"
                                                        :id="datatableUniqueKey + '_header_checkbox'"
                                                        :value="header"
                                                        @change="
                                                            saveColumnPreference(columnSequence);
                                                            changeSubrecordColumnHeaderVisibility(header);
                                                        "
                                                    />
                                                    <span> {{ header.label }}</span>
                                                </template>
                                            </div>
                                        </template>
                                    </transition-group>
                                </draggable>
                            </div>

                            <div class="column-filter-footer">
                                <button
                                    class="btn-rounded bordered danger text-white"
                                    @click="resetHeadersToDefault"
                                >
                                    {{ generalTranslations.reset ?? "Reset" }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <slot
                        name="view_mode_toggle"
                        :compact="compactView"
                        :toggleCompact="changeCompactView"
                        :hideDisplayHeaderFilter="hideDisplayHeaderFilter"
                    >
                        <div
                            class="toggle list-view-mode"
                            :hidden="hideDisplayHeaderFilter"
                        >
                            <label class="switch">
                                <input
                                    type="checkbox"
                                    class="toggle-compact"
                                    @change="changeCompactView"
                                    checked
                                />
                                <span class="slider round"></span>
                                <div class="icon-density">
                                    <i class="icon-densitydefault"></i>
                                    <i class="icon-densitycompact"></i>
                                </div>
                            </label>
                        </div>
                    </slot>

                    <slot name="trailing-slot"></slot>
                </div>
            </div>
            <slot name="announcement-bar"></slot>
        </slot>

        <data-table
            :class="{
                'bo-table': true,
                'is-compact': this.compactView,
                'no-title': !displayTitleHeader,
                'form-table-body': isForm,
                'has-data': Object.values(recordData).length > 0,
                'has-no-data': Object.values(recordData).length <= 0 && !isOverview,
                'is-overview': isOverview,
                'popup-modal-no-title': popupModalNoTitle,
            }"
            :style="overviewTableStyle()"
            :columns="[]"
            :classes="tableClasses"
            :perPage="perPage"
            :ref="'datatable_' + tableId"
            v-show="visible"
            :id="tableId + '_table'"
        >
            <div slot="filters"></div>

            <!-- Datatable Header -->
            <thead slot="header">
                <!-- search header -->
                <tr
                    class="enable-search"
                    v-if="enableSearch"
                >
                    <th
                        v-if="selectSingle && !selectMultiple"
                        class="row-checkbox-header"
                        :style="[
                            {
                                position: stickyHeader ? 'sticky' : 'initial',
                                'z-index': 9,
                            },
                        ]"
                    ></th>
                    <!-- <th v-else-if="selectMultiple || exportUrl" class="row-checkbox-header"></th> -->
                    <th
                        v-else-if="selectMultiple && hasVisibleColumns && hasSelectableRecord"
                        class="row-checkbox-header"
                        :style="[
                            {
                                position: stickyHeader ? 'sticky' : 'initial',
                                'z-index': 9,
                            },
                        ]"
                    ></th>

                    <template v-for="column in columns">
                        <th
                            :key="column.id"
                            v-if="!column.disabled"
                            v-show="column.visible"
                            :class="[column.type + '-header']"
                            :style="[
                                {
                                    position: stickyHeader ? 'sticky' : 'initial',
                                    'z-index': 'number' == column.type || 'currency' == column.type ? 9 : 9,
                                },
                            ]"
                        >
                            <slot :name="`${column.id}_column_header_content`">
                                <template v-if="false === column.searchable"></template>

                                <bo-date-range
                                    v-else-if="'datetime' == column.type"
                                    :id="column.id + '_header_datepicker'"
                                    :editable="true"
                                    :start="column.search ? column.search[0] : null"
                                    :end="column.search ? column.search[1] : null"
                                    :format="column.format"
                                    :separator="column.separator"
                                    :defaultStartText="column.defaultStartText"
                                    :defaultEndText="column.defaultEndText"
                                    :defaultEmptyText="column.defaultEmptyText"
                                    :showSeparatorIfEmpty="column.showSeparatorIfEmpty"
                                    @change="
                                        column.search = $event;
                                        updateDateSearch(column);
                                    "
                                >
                                </bo-date-range>

                                <bo-date-range
                                    v-else-if="'date_range' == column.type"
                                    :editable="true"
                                    :start="column.search ? column.search[0] : null"
                                    :end="column.search ? column.search[1] : null"
                                    :format="column.format"
                                    :separator="column.separator"
                                    :defaultStartText="column.defaultStartText"
                                    :defaultEndText="column.defaultEndText"
                                    :defaultEmptyText="column.defaultEmptyText"
                                    :showSeparatorIfEmpty="column.showSeparatorIfEmpty"
                                    @change="
                                        column.search = $event;
                                        updateRangeSearch(column);
                                    "
                                >
                                </bo-date-range>

                                <bo-search-number
                                    v-else-if="'number' == column.type || 'currency' == column.type"
                                    v-on:updateSearch="updateSearch(column)"
                                    :column="column"
                                    :id="column.id + '_header_search'"
                                    :parentId="id"
                                >
                                </bo-search-number>

                                <div
                                    class="select-wrapper"
                                    v-else-if="'select' == column.type || 'status' == column.type"
                                >
                                    <bo-select
                                        v-model="column.search"
                                        :options="column.options"
                                        :labels="!isEmpty(column.labels) ? column.labels : {}"
                                        :multiple="column.multiple"
                                        :nullable="true"
                                        :nullText="generalTranslations?.all ?? 'All'"
                                        @change="updateSearch(column)"
                                    >
                                    </bo-select>
                                </div>

                                <!-- <template v-else-if="'product' == column.type && true !== withoutProductAdvanceSearch">
                                <bo-search-product
                                    :ref="'search_' + column.id"
                                    :column="column"
                                    :parentId="id"
                                    v-on:searchProduct="updateSearch"
                                    v-on:advanceSearch="advanceSearch"
                                    :advanceSearchProductUrl="advanceSearchProductUrl"
                                    :advanceSearchProductOptionsUrl="advanceSearchProductOptionsUrl"
                                    :advanceSearchColumns="advanceSearchColumns"
                                ></bo-search-product>
                                </template> -->

                                <template v-else-if="'attachment' == column.type"> </template>

                                <!-- normal textbox -->
                                <input
                                    v-else
                                    v-model="column.search"
                                    class="search-input"
                                    type="text"
                                    :field="column.id"
                                    :id="column.id + '_header_search'"
                                    :placeholder="generalTranslations['search'] ?? 'Search'"
                                    @change="updateSearch(column)"
                                    @focus="changePopupVisibility($event, column)"
                                />
                            </slot>
                        </th>
                    </template>
                    <th
                        v-if="displayActionColumn"
                        class="row-action-cell"
                    ></th>

                    <th
                        style="min-width: 1px"
                        :style="[
                            {
                                position: stickyHeader ? 'sticky' : 'initial',
                                'z-index': 9,
                            },
                        ]"
                    >
                        <!-- spacer -->
                    </th>
                </tr>

                <tr :class="{ 'enable-search': enableSearch }">
                    <th
                        v-if="selectSingle && !selectMultiple"
                        class="row-checkbox-header"
                        :style="[
                            {
                                position: stickyHeader ? 'sticky' : 'initial',
                                'z-index': 9,
                            },
                        ]"
                    ></th>
                    <th
                        v-if="selectMultiple && hasVisibleColumns && hasSelectableRecord"
                        class="row-checkbox-header"
                        :style="[
                            {
                                position: stickyHeader ? 'sticky' : 'initial',
                                'z-index': 9,
                            },
                        ]"
                    >
                        <div class="d-flex">
                            <template v-if="hasSubrecord">
                                <div
                                    data-toggle="collapse"
                                    class="indicator"
                                    aria-expanded="false"
                                >
                                    <div class="icon-placeholder"></div>
                                </div>
                            </template>
                            <input
                                type="checkbox"
                                v-model="headerChecked"
                                :id="datatableUniqueKey + '_header_checkbox'"
                                @change="checkAllRecords"
                            />
                        </div>
                    </th>
                    <template v-for="column in columns">
                        <th
                            @click="sort(column)"
                            :key="column.id"
                            :class="[
                                column.type + '-header',
                                {
                                    sorting: column.orderable,
                                    sorting_asc: sortColumn == column.id && dir == 'asc',
                                    sorting_desc: sortColumn == column.id && dir == 'desc',
                                },
                            ]"
                            :id="column.id + '_header_sort'"
                            v-if="!column.disabled"
                            v-show="column.visible"
                            :style="[
                                {
                                    position: stickyHeader ? 'sticky' : 'initial',
                                    'z-index': 9,
                                },
                            ]"
                        >
                            <span>{{ column.label }}</span>
                        </th>
                    </template>
                    <th
                        v-if="displayActionColumn"
                        class="row-action-cell"
                    >
                        {{ generalTranslations?.action ?? "Action" }}
                    </th>
                    <th
                        style="min-width: 1px"
                        :style="[
                            {
                                position: stickyHeader ? 'sticky' : 'initial',
                                'z-index': 9,
                            },
                        ]"
                    >
                        <!-- spacer -->
                    </th>
                </tr>
            </thead>

            <!-- Datatable body -->
            <tbody slot="body">
                <template v-for="record in recordData">
                    <tr
                        :key="record[primaryKey]"
                        :class="[
                            record[primaryKey] in rowWarningOptions ? 'no-stock' : '',
                            subrecordClass(record),
                            { 'selected-row': isSelected(record[primaryKey]) },
                        ]"
                        @click="
                            selectSingle
                                ? selectSingleHandler($event, record[primaryKey])
                                : selectMultipleHandler($event, record[primaryKey])
                        "
                        @change="selectMultiple ? selectMultipleHandler($event, record[primaryKey]) : null"
                        @click.right="showContextMenu($event, record, tableId)"
                    >
                        <!-- able to select row -->
                        <template v-if="hasVisibleColumns">
                            <td
                                v-if="selectSingle && selectableRecords[record[primaryKey]] != null"
                                class="row-checkbox-cell"
                                :class="hasSubrecord ? 'isCollapsible' : ''"
                            >
                                <div class="d-flex">
                                    <template v-if="hasSubrecord">
                                        <div
                                            data-toggle="collapse"
                                            class="indicator"
                                            aria-expanded="false"
                                        >
                                            <i
                                                v-if="
                                                    typeof record.subrecords !== 'undefined' && record.subrecords.length
                                                "
                                                :class="[
                                                    'icon icon-expandmore',
                                                    'cursor-pointer',
                                                    {
                                                        collapsed: record.subrecordVisibility !== true,
                                                        expanded: record.subrecordVisibility === true,
                                                    },
                                                ]"
                                                @click="changeSubRecordVisibility(record)"
                                            ></i>
                                            <div
                                                v-else
                                                class="icon-placeholder"
                                            ></div>
                                        </div>
                                    </template>
                                    <input
                                        type="radio"
                                        name="datatable-radio"
                                        :checked="record.checked"
                                        @click.stop="selectSingleHandler($event, record[primaryKey])"
                                    />
                                </div>
                            </td>
                            <td
                                v-else-if="selectMultiple && selectableRecords[record[primaryKey]] != null"
                                class="row-checkbox-cell"
                                :class="hasSubrecord ? 'isCollapsible' : ''"
                            >
                                <div class="d-flex">
                                    <template v-if="hasSubrecord">
                                        <div
                                            data-toggle="collapse"
                                            class="indicator"
                                            aria-expanded="false"
                                        >
                                            <i
                                                v-if="
                                                    typeof record.subrecords !== 'undefined' && record.subrecords.length
                                                "
                                                :class="[
                                                    'icon icon-expandmore',
                                                    'cursor-pointer',
                                                    {
                                                        collapsed: record.subrecordVisibility !== true,
                                                        expanded: record.subrecordVisibility === true,
                                                    },
                                                ]"
                                                @click="changeSubRecordVisibility(record)"
                                            ></i>
                                            <div
                                                v-else
                                                class="icon-placeholder"
                                            ></div>
                                        </div>
                                    </template>
                                    <input
                                        type="checkbox"
                                        :id="datatableUniqueKey + '_body_checkbox'"
                                        v-if="checkSelectableRowCondition(record)"
                                        :value="record.checked"
                                        :checked="record.checked"
                                        @change="selectMultipleHandler($event, record[primaryKey])"
                                    />
                                </div>
                            </td>
                            <td
                                v-else-if="selectSingle || selectMultiple"
                                class="row-checkbox-cell"
                                :class="hasSubrecord ? 'isCollapsible' : ''"
                            >
                                <div class="d-flex">
                                    <template v-if="hasSubrecord">
                                        <div
                                            data-toggle="collapse"
                                            class="indicator"
                                            aria-expanded="false"
                                        >
                                            <i
                                                v-if="
                                                    typeof record.subrecords !== 'undefined' && record.subrecords.length
                                                "
                                                :class="[
                                                    'icon icon-expandmore',
                                                    'cursor-pointer',
                                                    {
                                                        collapsed: record.subrecordVisibility !== true,
                                                        expanded: record.subrecordVisibility === true,
                                                    },
                                                ]"
                                                @click="changeSubRecordVisibility(record)"
                                            ></i>
                                            <div
                                                v-else
                                                class="icon-placeholder"
                                            ></div>
                                        </div>
                                    </template>
                                    <input
                                        :type="selectSingle ? 'radio' : 'checkbox'"
                                        :disabled="true"
                                    />
                                </div>
                            </td>
                        </template>
                        <template v-for="(column, columnKey) in columns">
                            <td
                                :class="[
                                    column.id.replace('_', '-'),
                                    column.type + '-cell',
                                    {
                                        'is-collapsible':
                                            0 === columnKey &&
                                            hasSubrecord &&
                                            record.subrecords &&
                                            record.subrecords.length,
                                    },
                                ]"
                                :id="column.id + '_body_' + column.type"
                                :key="column.id"
                                v-if="!column.disabled"
                                v-show="column.visible"
                            >
                                <!-- if have subrecord, show arrow at first column -->
                                <i
                                    v-if="
                                        0 === columnKey &&
                                        typeof record.subrecords !== 'undefined' &&
                                        record.subrecords.length
                                    "
                                    :class="[
                                        'icon icon-expandmore',
                                        'cursor-pointer',
                                        {
                                            collapsed: record.subrecordVisibility !== true,
                                            expanded: record.subrecordVisibility === true,
                                        },
                                    ]"
                                    @click="changeSubRecordVisibility(record)"
                                ></i>

                                <div class="d-flex align-items-center">
                                    <slot
                                        :name="`${column.id}_column`"
                                        :column="column"
                                        :record="record"
                                        :editRecordHandler="editRecordFn(record[primaryKey], column)"
                                        :getData="getData"
                                    >
                                        <!-- if data can edit -->
                                        <template
                                            v-if="
                                                true == editable &&
                                                true == column.editable &&
                                                isRecordEditable(record, column)
                                            "
                                        >
                                            <bo-cell-number
                                                v-if="'number' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :decimal="column.decimal"
                                                :currency="column.currency"
                                                :negative="column.negative"
                                                :sign="column.sign"
                                                :min="column.min"
                                                :max="column.maxTransform(record)"
                                                :displayMax="column.displayMax"
                                                :editable="true"
                                                :value="column.transform(record)"
                                                :eager="column.eager"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                            >
                                            </bo-cell-number>

                                            <bo-cell-currency
                                                v-else-if="'currency' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :decimal="column.decimal"
                                                :currency="column.currency"
                                                :negative="column.negative"
                                                :sign="column.sign"
                                                :min="column.min"
                                                :max="column.max"
                                                :editable="true"
                                                :value="column.transform(record)"
                                                :eager="column.eager"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                            >
                                            </bo-cell-currency>

                                            <bo-date-range
                                                v-else-if="'date_range' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :editable="true"
                                                :value="column.transform(record)"
                                                :start="record[column.start_id]"
                                                :end="record[column.end_id]"
                                                :format="column.format"
                                                :separator="column.separator"
                                                :defaultStartText="column.defaultStartText"
                                                :defaultEndText="column.defaultEndText"
                                                :defaultEmptyText="column.defaultEmptyText"
                                                :showSeparatorIfEmpty="column.showSeparatorIfEmpty"
                                                :showNullIfEmpty="column.showNullIfEmpty"
                                                :includeEndDay="column.includeEndDay"
                                                :simple="true"
                                            >
                                            </bo-date-range>

                                            <bo-cell-attachment
                                                v-else-if="'attachment' == column.type"
                                                :value="column.transform(record)"
                                                :id="column.id + '_body_' + column.type"
                                                :meta="column.meta"
                                                :editable="true"
                                                :url="column.url.uploadUrl"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                                @loading="showLoading"
                                                @done_loading="hideLoading"
                                            >
                                            </bo-cell-attachment>

                                            <bo-cell-status
                                                v-else-if="'status' == column.type"
                                                :value="column.transform(record)"
                                                :id="column.id + '_body_' + column.type"
                                                :editable="true"
                                                :editableCondition="column.editableCondition"
                                                :options="column.options"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                            >
                                            </bo-cell-status>

                                            <bo-select
                                                v-else-if="'select' == column.type"
                                                :value="column.transform(record)"
                                                :disabled="!column.editable"
                                                :readonly="!column.editable"
                                                :id="column.id + '_body_' + column.type"
                                                :options="column.options"
                                                :labels="!isEmpty(column.labels) ? column.labels : {}"
                                                :multiple="column.multiple"
                                                :nullable="column.nullable"
                                                :nullText="column.nullText"
                                                :plain="column.plain"
                                                :is-form="true"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                            >
                                            </bo-select>

                                            <bo-select-popup
                                                v-else-if="'select_popup' == column.type"
                                                :select-multiple="false"
                                                :select-single="true"
                                                :editable="true"
                                                :columns="column.columns"
                                                :url="column.addRecordsUrl"
                                                :initial-records="column.transform(record)"
                                                :modal-title="
                                                    Object.keys(generalTranslations).length === 0
                                                        ? generalTranslations?.select_object?.replace(
                                                              ':object',
                                                              column.label
                                                          ) ?? 'Select ' + column.label
                                                        : 'Select ' + column.label
                                                "
                                                @trigger="saveRecordstoColumn(record[primaryKey], column, ...arguments)"
                                                @change="
                                                    editRecordHandler(record[primaryKey], $event.target.value, column)
                                                "
                                            >
                                            </bo-select-popup>
                                            <!-- :initial-records="record[column.id]" -->
                                            <bo-cell-product
                                                v-else-if="'product' == column.type"
                                                :ref="'assignProduct_' + record[primaryKey]"
                                                :id="column.id + '_body_' + column.type"
                                                :parentId="id"
                                                :value="column.transform(record)"
                                                :editable="true"
                                                :getProductUrl="column.url.advanceSearchProductUrl"
                                                :getProductOptionsUrl="column.url.advanceSearchProductOptionsUrl"
                                                :columns="column.meta.advanceSearchColumns"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                            ></bo-cell-product>

                                            <bo-cell-multiselect
                                                v-else-if="'multiselect' == column.type"
                                                :ref="'assignMultiselect_' + record[primaryKey]"
                                                :id="column.id + '_body_' + column.type"
                                                :title="resolvePlaceholders(column.title, record)"
                                                :subtitle="column.subtitle"
                                                :parentId="id"
                                                :value="column.transform(record)"
                                                :meta="column.meta"
                                                :editable="true"
                                                :selectSingleItem="column.selectSingleItem"
                                                :getItemsUrl="resolveURL(column.url.getItemsUrl, record[primaryKey])"
                                                :columns="column.meta.addItemsColumns"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                                @add="
                                                    $emit(`multiselect_add_${column.id} `, record[primaryKey], $event)
                                                "
                                                @delete="
                                                    $emit(
                                                        `multiselect_delete_${column.id} `,
                                                        record[primaryKey],
                                                        $event
                                                    )
                                                "
                                            ></bo-cell-multiselect>

                                            <bo-cell-per-total
                                                v-else-if="'per_total' == column.type"
                                                :ref="'perTotal_' + record[primaryKey]"
                                                :id="column.id + '_body_' + column.type"
                                                :parentId="id"
                                                :meta="column.meta"
                                                :editable="true"
                                                :eager="column.eager"
                                                :value="column.transform(record)"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                            >
                                            </bo-cell-per-total>

                                            <bo-cell-mode-input-number
                                                v-else-if="'mode_input_number' == column.type"
                                                :id="column.id"
                                                class="form-control"
                                                :value="record[column.id].value"
                                                :options="record[column.id].options"
                                                :selected="record[column.id].selected"
                                                :meta="column.meta"
                                                :editable="true"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                                @value_change="
                                                    modifyRecord(
                                                        `mode_input_number_value_change_${column.id} `,
                                                        record[primaryKey],
                                                        $event
                                                    )
                                                "
                                                @selected_change="
                                                    modifyRecord(
                                                        `mode_input_number_selected_change_${column.id} `,
                                                        record[primaryKey],
                                                        $event
                                                    )
                                                "
                                            >
                                            </bo-cell-mode-input-number>

                                            <bo-cell-toggle
                                                v-else-if="'toggle' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :value="column.transform(record)"
                                                :editable="column.editable"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                            >
                                            </bo-cell-toggle>

                                            <bo-cell-html
                                                v-else-if="'html' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :value="column.transform(record)"
                                            ></bo-cell-html>

                                            <bo-cell-custom-toggle
                                                v-else-if="'custom-toggle' == column.type"
                                                :value="column.transform(record)"
                                                :id="column.id + '_body_' + column.type"
                                                :column="column"
                                                :record="record"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                            >
                                            </bo-cell-custom-toggle>
                                            <slot
                                                v-else
                                                :name="`${column.id}_column`"
                                                :record="record"
                                                :column="column"
                                                :editRecordHandler="editRecordHandler"
                                            >
                                                <input
                                                    type="text"
                                                    class="form-control dynamic-width"
                                                    style="width: auto"
                                                    ref="tableInput"
                                                    @input="updateWidth($event)"
                                                    :value="
                                                        typeof column.transform != 'undefined'
                                                            ? column.transform(record)
                                                            : record[column.id]
                                                    "
                                                    @change="
                                                        editRecordHandler(
                                                            record[primaryKey],
                                                            $event.target.value,
                                                            column
                                                        )
                                                    "
                                                />
                                            </slot>
                                        </template>

                                        <!-- if data cannot edit -->
                                        <template v-else>
                                            <bo-cell-status
                                                v-if="'status' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :value="column.transform(record)"
                                            >
                                            </bo-cell-status>

                                            <bo-select
                                                v-else-if="'select' == column.type"
                                                :value="column.transform(record)"
                                                :disabled="!column.editable"
                                                :readonly="!column.editable"
                                                :id="column.id + '_body_' + column.type"
                                                :options="column.options"
                                                :labels="column.labels"
                                                :multiple="column.multiple"
                                                :nullable="column.nullable"
                                                :plain="column.plain"
                                                :is-form="true"
                                                @change="editRecordHandler(record[primaryKey], $event, column)"
                                            >
                                            </bo-select>

                                            <bo-cell-datetime
                                                v-else-if="'datetime' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :format="column.format"
                                                :momentLocale="generalTranslations?.momentLocale ?? 'en'"
                                                :value="column.transform(record)"
                                                :editable="false"
                                                :placeholder="column.placeholder"
                                            >
                                            </bo-cell-datetime>

                                            <bo-date-range
                                                v-else-if="'date_range' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :value="column.transform(record)"
                                                :start="record[column.start_id]"
                                                :end="record[column.end_id]"
                                                :format="column.format"
                                                :separator="column.separator"
                                                :defaultStartText="column.defaultStartText"
                                                :defaultEndText="column.defaultEndText"
                                                :defaultEmptyText="column.defaultEmptyText"
                                                :showSeparatorIfEmpty="column.showSeparatorIfEmpty"
                                                :showNullIfEmpty="column.showNullIfEmpty"
                                                :includeEndDay="column.includeEndDay"
                                                :simple="true"
                                            >
                                            </bo-date-range>

                                            <bo-cell-number
                                                v-else-if="'number' == column.type"
                                                class="w-100"
                                                :id="column.id + '_body_' + column.type"
                                                :decimal="column.decimal"
                                                :currency="column.currency"
                                                :negative="column.negative"
                                                :sign="column.sign"
                                                :min="column.min"
                                                :max="column.maxTransform(record)"
                                                :displayMax="column.displayMax"
                                                :editable="false"
                                                :value="column.transform(record)"
                                                :eager="column.eager"
                                            >
                                            </bo-cell-number>

                                            <bo-cell-currency
                                                v-else-if="'currency' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :decimal="column.decimal"
                                                :currency="column.currency"
                                                :negative="column.negative"
                                                :sign="column.sign"
                                                :min="column.min"
                                                :max="column.max"
                                                :editable="false"
                                                :value="column.transform(record)"
                                                :eager="column.eager"
                                            >
                                            </bo-cell-currency>

                                            <bo-cell-product
                                                v-else-if="'product' == column.type"
                                                editable="false"
                                                :value="column.transform(record)"
                                            >
                                            </bo-cell-product>

                                            <bo-cell-multiselect
                                                v-else-if="'multiselect' == column.type"
                                                :ref="'assignDocument_' + record[primaryKey]"
                                                :id="column.id + '_body_' + column.type"
                                                :parentId="id"
                                                :value="column.transform(record)"
                                                :meta="column.meta"
                                                :editable="false"
                                            ></bo-cell-multiselect>

                                            <bo-cell-per-total
                                                v-else-if="'per_total' == column.type"
                                                :ref="'perTotal_' + record[primaryKey]"
                                                :id="column.id + '_body_' + column.type"
                                                :parentId="id"
                                                :meta="column.meta"
                                                :editable="false"
                                                :value="column.transform(record)"
                                            >
                                            </bo-cell-per-total>

                                            <bo-cell-user
                                                v-else-if="'user' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :value="column.transform(record)"
                                            >
                                            </bo-cell-user>

                                            <bo-cell-link
                                                v-else-if="'link' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :link="column.getLink(record)"
                                                :label="column.transform(record)"
                                                :target="column.target"
                                            >
                                            </bo-cell-link>

                                            <bo-cell-link
                                                v-else-if="'link2' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :link="window.bo.overviewUrl + '/' + record['id']"
                                                :label="record[column.id]"
                                                :target="column.meta.target"
                                            >
                                            </bo-cell-link>

                                            <bo-cell-attachment
                                                v-else-if="'attachment' == column.type"
                                                :value="column.transform(record)"
                                                :id="column.id + '_body_' + column.type"
                                                :meta="column.meta"
                                                :editable="false"
                                                @loading="showLoading"
                                                @done_loading="hideLoading"
                                            >
                                            </bo-cell-attachment>

                                            <bo-cell-mode-input-number
                                                v-else-if="'mode_input_number' == column.type"
                                                :id="column.id"
                                                class="form-control"
                                                :value="record[column.id].value"
                                                :options="record[column.id].options"
                                                :selected="record[column.id].selected"
                                                :meta="column.meta"
                                                :editable="false"
                                            >
                                            </bo-cell-mode-input-number>
                                            <bo-cell-html
                                                v-else-if="'html' == column.type"
                                                :value="column.transform(record)"
                                            >
                                            </bo-cell-html>
                                            <!-- <div
                                                v-else-if="'htmll' == column.type"
                                                v-html="column.transform(record)"
                                            ></div> -->

                                            <bo-cell-toggle
                                                v-else-if="'toggle' == column.type"
                                                :id="column.id + '_body_' + column.type"
                                                :value="column.transform(record)"
                                                :editable="column.editable"
                                            >
                                            </bo-cell-toggle>

                                            <slot
                                                v-else
                                                :name="`${column.id}_column`"
                                                :record="record"
                                                :column="column"
                                                :editRecordHandler="editRecordHandler"
                                            >
                                                <div
                                                    class="d-flex align-items-center"
                                                    :id="column.id + '_body_' + column.type"
                                                >
                                                    <span>{{
                                                        typeof column.transform != "undefined"
                                                            ? column.transform(record)
                                                            : record[column.id]
                                                    }}</span>
                                                </div>
                                            </slot>
                                        </template>
                                    </slot>
                                    <slot
                                        :name="`${column.id}_column_right_content`"
                                        :record="record"
                                    >
                                    </slot>
                                </div>
                            </td>
                        </template>

                        <td
                            class="row-action-cell"
                            v-if="displayActionColumn"
                        >
                            <!-- <template v-if="deleteSingle">
                                <i
                                    class="icon-arclight icon-deleteforever remove"
                                    :key="record[primaryKey]"
                                    @click="deleteRecord(record[primaryKey])"
                                ></i>
                            </template> -->
                            <!-- Should be a slot -->
                            <!-- <template v-if="record.attachment_url">
                                <i
                                    class="icon-arclight icon-attachfile attachment-download"
                                    @click="downloadAttachment(record)"
                                ></i>
                            </template> -->
                            <div class="more">
                                <i
                                    class="icon-morehorizontal cursor-pointer dropdown-trigger"
                                    id="more-menu"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                ></i>
                                <div
                                    class="bo-context-menu-more dropdown-menu"
                                    aria-labelledby="more-menu"
                                >
                                    <template v-if="editSingle">
                                        <div
                                            class="context-item"
                                            @click="goToUrl(record[primaryKey])"
                                        >
                                            <div class="item-command">
                                                <i class="icon-arclight icon-edit"></i>
                                                <span>{{ generalTranslations?.edit ?? "Edit" }}</span>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="viewSingle">
                                        <div
                                            class="context-item"
                                            @click="goToUrl(record[primaryKey])"
                                        >
                                            <div class="item-command">
                                                <i class="icon-arclight icon-visibility"></i>
                                                <span>{{ generalTranslations?.view ?? "View" }}</span>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="viewLogSingle">
                                        <div
                                            class="context-item"
                                            @click="goToLogUrl(record[primaryKey])"
                                        >
                                            <div class="item-command">
                                                <i class="icon-arclight icon-visibility"></i>
                                                <span>{{ generalTranslations?.view_records ?? "View Records" }}</span>
                                            </div>
                                        </div>
                                    </template>
                                    <slot
                                        name="action_menu"
                                        :record="record"
                                        :record_id="record[primaryKey]"
                                    ></slot>
                                    <template v-if="editSingleInModal">
                                        <div class="context-item">
                                            <div class="item-command">
                                                <i class="icon-arclight icon-edit"></i>
                                                <span>{{ generalTranslations?.edit ?? "Edit" }}</span>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="(deleteSingle || deleteMultiple) && isRecordDeletable(record)">
                                        <div
                                            class="context-item delete-item"
                                            @click="deleteRecord(record[primaryKey])"
                                        >
                                            <div class="item-command">
                                                <i
                                                    class="icon-arclight icon-deleteforever"
                                                    :key="record[primaryKey]"
                                                ></i>
                                                <span>{{ generalTranslations?.delete ?? "Delete" }}</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </td>

                        <td style="min-width: 1px">
                            <!-- spacer -->
                        </td>
                    </tr>

                    <template
                        v-if="
                            hasSubrecord &&
                            record.subrecords &&
                            record.subrecords.length &&
                            record.subrecordVisibility === true
                        "
                    >
                        <bo-datatable-subrecord
                            v-for="subrecord in record.subrecords"
                            :id="subrecord.id"
                            :prepend="selectMultiple"
                            :key="record[primaryKey] + '_' + subrecord[primaryKey]"
                            :columns="subrecordColumns"
                            :item="subrecord"
                            :enableDeleteRecord="enableDeleteRecord && deleteSubrecord"
                            :show-subrecord-action-menu="showSubrecordActionMenu"
                            :row-class="[
                                record[primaryKey] in rowWarningOptions ? 'no-stock' : '',
                                subrecordClass(record),
                            ]"
                            @change="subrecordChangeHandler(record[primaryKey], subrecord[primaryKey], ...arguments)"
                            @delete="subrecordDeleteHandler(record[primaryKey], subrecord[primaryKey], ...arguments)"
                            @loading="showLoading"
                            @done_loading="hideLoading"
                        >
                            <template
                                v-for="column in subrecordSlotColumns"
                                v-slot:[column.id]
                            >
                                <slot
                                    :name="`${column.id}_subrecord_column`"
                                    :record="subrecord"
                                    :column="column"
                                ></slot>
                            </template>
                        </bo-datatable-subrecord>
                    </template>
                </template>

                <!-- local search keeps the row mounted (hidden) so its illustration is already loaded when needed -->
                <template v-if="showEmptyData || localSearchSort">
                    <tr
                        v-show="showEmptyData"
                        class="bo-empty-data"
                    >
                        <td
                            :colspan="emptyRowColspan"
                            class="no-data"
                        >
                            <div class="no-result-found">
                                <bo-svg
                                    :svg-content="'/assets/graphics/img-no-data.svg'"
                                    :primary-color="primaryColor"
                                ></bo-svg>
                                <!-- <i class="icon-no-data"></i> -->
                                <div class="title">
                                    {{ generalTranslations?.no_results_found ?? "No results found" }}
                                </div>
                                <!-- <div class="subtitle">Currently does not have any data to display</div> -->
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>

            <!-- Datatable footer -->
            <div slot="pagination"></div>
        </data-table>

        <PortalTarget name="popup-section"></PortalTarget>

        <div
            v-show="showMenu"
            :style="{ top: `${menuPosition.y}px`, left: `${menuPosition.x}px` }"
            class="custom-menu"
            v-if="editSingle || viewSingle || viewLogSingle || deleteSingle || deleteMultiple"
        >
            <template v-if="editSingle">
                <div
                    class="context-item"
                    @click="goToUrl(selectedRow.id)"
                >
                    <div class="item-command">
                        <i class="icon-arclight icon-edit"></i>
                        <span>{{ generalTranslations?.edit ?? "Edit" }}</span>
                    </div>
                </div>
            </template>
            <template v-if="viewSingle">
                <div
                    class="context-item"
                    @click="goToUrl(selectedRow.id)"
                >
                    <div class="item-command">
                        <i class="icon-arclight icon-visibility"></i>
                        <span>{{ generalTranslations?.view ?? "View" }}</span>
                    </div>
                </div>
            </template>
            <template v-if="viewLogSingle">
                <div
                    class="context-item"
                    @click="goToLogUrl(selectedRow.id)"
                >
                    <div class="item-command">
                        <i class="icon-arclight icon-visibility"></i>
                        <span>{{ generalTranslations?.view_records ?? "View Records" }}</span>
                    </div>
                </div>
            </template>
            <slot
                name="custom_menu"
                :record="recordsById[selectedRow?.id] ?? null"
            ></slot>
            <template v-if="(deleteSingle || deleteMultiple) && isRecordDeletable(recordsById[selectedRow?.id])">
                <div
                    class="context-item delete-item"
                    @click="deleteRecord(selectedRow.id)"
                >
                    <div class="item-command">
                        <i
                            class="icon-arclight icon-deleteforever"
                            :key="'selectedRow.id'"
                        ></i>
                        <span>{{ generalTranslations?.delete ?? "Delete" }}</span>
                    </div>
                </div>
            </template>
        </div>

        <!-- end of popup section -->
        <slot name="footer"></slot>

        <div
            v-if="pagination"
            class="table-footer bo-table-footer has-pagination"
        >
            <div class="total">
                <div class="total-count title">
                    {{
                        generalTranslations.show_pagination
                            ? generalTranslations.show_pagination
                                  .replace(":first", formattedTotal(pagination.from))
                                  .replace(
                                      ":last",
                                      formattedTotal(
                                          (pagination.current_page - 1) * pagination.per_page +
                                              Object.keys(records).length
                                      )
                                  )
                                  .replace(":total", formattedTotal(pagination.total))
                            : "Showing ".concat(
                                  formattedTotal(pagination.from),
                                  " - ",
                                  formattedTotal(
                                      (pagination.current_page - 1) * pagination.per_page + Object.keys(records).length,
                                      " of ",
                                      formattedTotal(pagination.total)
                                  )
                              )
                    }}
                    <!-- Showing {{ formattedTotal(pagination.from) }} -
                    {{
                        formattedTotal(
                            (pagination.current_page - 1) * pagination.per_page + Object.keys(records).length
                        )
                    }}
                    of {{ formattedTotal(pagination.total) }} -->
                </div>
                <div class="rows-per-page-total">
                    {{ generalTranslations?.rows ?? "Rows" }}

                    <!-- have watcher -->
                    <select v-model="limitPerPage">
                        <option
                            v-for="(limit, index) in perPage"
                            :key="index"
                        >
                            {{ limit }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="pagination">
                <div class="rows-per-page">
                    <span> {{ generalTranslations?.rows ?? "Rows" }} </span>

                    <!-- have watcher -->
                    <select v-model="limitPerPage">
                        <option
                            v-for="(limit, index) in perPage"
                            :key="index"
                        >
                            {{ limit }}
                        </option>
                    </select>
                </div>

                <div class="page-navigation">
                    <div class="pages">
                        <span
                            v-for="(link, index) in pagination.links"
                            :key="index"
                        >
                            <a
                                v-if="link.label == 'pagination.previous'"
                                :key="link.label"
                                @click="changePage(link.url)"
                                :class="{ active: link.active }"
                            >
                                <i class="icon-chevronleft"></i>
                            </a>

                            <a
                                v-else-if="link.label == 'pagination.next'"
                                :key="link.label"
                                @click="changePage(link.url)"
                                :class="{ active: link.active }"
                            >
                                <i class="icon-chevronright"></i>
                            </a>

                            <a
                                v-else
                                :key="link.label"
                                @click="changePage(link.url)"
                                :class="{ active: link.active }"
                            >
                                {{ link.label }}
                            </a>
                        </span>
                    </div>

                    <div class="go-to">
                        <span>{{ generalTranslations?.page ?? "Page" }}</span>
                        <input
                            type="number"
                            v-model="pageNumber"
                        />
                        <button
                            class="btn-go"
                            @click="goToPage()"
                            :disabled="pageNumber == ''"
                        >
                            {{ generalTranslations?.go ?? "Go" }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!--
    <bo-datatable-footer
      :getRecordsUrl.sync="getRecordsUrl"
      :modified="modified"
      :dataUrl="dataUrl"
      :tableFooter="tableFooter"
      ref="footer"
    ></bo-datatable-footer> -->
        <bo-confirmation ref="bo_confirmation"></bo-confirmation>
    </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import DataTable from "laravel-vue-datatable";
Vue.use(DataTable);
import draggable from "vuedraggable";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueNumeric from "vue-numeric";
import moment, { max } from "moment";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);
import VueLazyLoad from "vue-lazyload";
Vue.use(VueLazyLoad);
import PortalVue from "portal-vue";
Vue.use(PortalVue);
import boConfirmation from "@/v2/components/bo-confirmation.vue";
import overviewTableHeightMixin from "@/v2/mixins/overview-table-height.js";
Vue.component("bo-confirmation", boConfirmation);
import boDatatableRow from "@/bo-datatable/bo-datatable-subrecord.vue";
Vue.component("bo-datatable-subrecord", boDatatableRow);
import boCellProduct from "@/bo-datatable/bo-cell-product.vue";
Vue.component("bo-cell-product", boCellProduct);
import boCellMultiselect from "@/bo-datatable/bo-cell-multiselect.vue";
Vue.component("bo-cell-multiselect", boCellMultiselect);
import boCellPerTotal from "@/bo-datatable/bo-cell-per-total.vue";
Vue.component("bo-cell-per-total", boCellPerTotal);
import boCellAttachment from "@/bo-datatable/bo-cell-attachment.vue";
Vue.component("bo-cell-attachment", boCellAttachment);
import boSelect from "@/v2/components/bo-select.vue";
Vue.component("bo-select", boSelect);
import boCellHtml from "@/bo-datatable/bo-cell-html.vue";
Vue.component("bo-cell-html", boCellHtml);
import boCellStatus from "@/bo-datatable/bo-cell-status.vue";
Vue.component("bo-cell-status", boCellStatus);
import boCellNumber from "@/v2/components/bo-cell-number.vue";
Vue.component("bo-cell-number", boCellNumber);
import boCellCurrency from "@/v2/components/bo-cell-currency.vue";
Vue.component("bo-cell-currency", boCellCurrency);
import boCellDatetime from "@/v2/components/bo-cell-datetime.vue";
Vue.component("bo-cell-datetime", boCellDatetime);
import boDateRange from "@/v2/components/bo-date-range.vue";
Vue.component("bo-date-range", boDateRange);
import boCellLink from "@/bo-datatable/bo-cell-link.vue";
Vue.component("bo-cell-link", boCellLink);
import boCellUser from "@/bo-datatable/bo-cell-user.vue";
Vue.component("bo-cell-user", boCellUser);
import boSearchProduct from "@/bo-datatable/bo-search-product.vue";
Vue.component("bo-search-product", boSearchProduct);
import boSearchNumber from "@/v2/components/bo-search-number.vue";
Vue.component("bo-search-number", boSearchNumber);
import boCellModeInputNumber from "@/bo-datatable/bo-cell-mode-input-number.vue";
Vue.component("bo-cell-mode-input-number", boCellModeInputNumber);
import boAdvanceSearch from "@/bo-datatable/bo-advance-search.vue";
Vue.component("bo-advance-search", boAdvanceSearch);
import boCellToggle from "@/v2/components/bo-cell-toggle.vue";
Vue.component("bo-cell-toggle", boCellToggle);
import boCellCustomToggle from "@/v2/components/bo-cell-custom-toggle.vue";
Vue.component("bo-cell-custom-toggle", boCellCustomToggle);
import boSelectPopup from "@/v2/components/bo-select-popup.vue";
Vue.component("bo-select-popup", boSelectPopup);
Vue.component("bo-svg", require("js/frontend/components/bo-svg.vue").default);

import { confirmationMixin } from "@/v2/mixins/bo-confirmation.js";
import { Prompt } from "@/v2/models/bo-confirmation.js";
import httpMixin from "@/v2/mixins/http.js";
import columnPreferenceMixin from "@/v2/mixins/column-preference.js";
import * as utils from "@/v2/utils/utilities.js";

import { VueContextmenu } from "v-contextmenu";

axios.defaults.headers.common["X-CSRF-TOKEN"] = document.getElementsByName("X-CSRF-TOKEN")[0].getAttribute("content");

export default {
    inject: {
        triggerPopupModalAction: {
            from: "triggerPopupModalAction",
            default: () => {},
        },
    },
    mixins: [confirmationMixin, httpMixin, columnPreferenceMixin, overviewTableHeightMixin],
    props: {
        id: {
            type: String,
            default: "",
        },
        primaryKey: {
            type: String,
            default: "id",
        },
        title: {
            type: String,
            default: "",
        },
        editable: {
            type: Boolean,
            default: true,
        },
        // Callback to determine if a record is editable. Accepts a record and column as parameters
        recordEditable: {
            type: Function,
            default: null,
        },
        // Callback to determine if a record is selectable. Accepts a record as parameter
        recordSelectable: {
            type: Function,
            default: null,
        },
        recordDeletable: {
            type: Function,
            default: null,
        },
        selectSingle: {
            type: Boolean,
            default: false,
        },
        selectMultiple: {
            type: Boolean,
            default: false,
        },
        selectRecordPrefix: {
            type: String,
            default: "",
        },
        selectRowConditions: {
            type: [Object, Array],
            default: () => ({}),
        },
        //Columns, records, subrecords all have to be indexed by primary key
        columns: {
            type: Object,
            default: () => ({}),
        },
        subrecordColumns: {
            type: Object,
            default: () => ({}),
        },
        showSubrecordActionMenu: {
            type: Boolean,
            default: false,
        },
        deleteSubrecord: {
            type: Boolean,
            default: true,
        },
        displayTitleHeader: {
            type: Boolean,
            default: true,
        },
        skipPortal: {
            type: Boolean,
            default: false,
        },
        records: {
            type: [Array, Object],
            default: null,
        },
        pagination: {
            type: Object,
            default: null,
        },
        headers: {
            type: Object,
            default: () => ({}),
        },
        defaultLimit: {
            type: Number,
            default: 50,
        },
        enableUpdateRecord: {
            type: Boolean,
            default: false,
        },
        enableDeleteRecord: {
            type: Boolean,
            default: false,
        },
        enableDeleteSingleRecord: {
            type: Boolean,
            default: false,
        },
        enableDeleteMultipleRecords: {
            type: Boolean,
            default: false,
        },
        enableEditRecord: {
            type: Boolean,
            default: false,
        },
        enableEditRecordModal: {
            type: Boolean,
            default: false,
        },
        enableViewRecord: {
            type: Boolean,
            default: false,
        },
        enableViewLogRecord: {
            type: Boolean,
            default: false,
        },
        enableViewSelectedRecords: {
            type: Boolean,
            default: false,
        },
        // Whether the table allow search
        enableSearch: {
            type: Boolean,
            default: true,
        },
        // Whether to use external prompting mechanisms to prevent double prompting
        // If true, then a prompt event will be fired
        externalPrompt: {
            type: Boolean,
            default: false,
        },
        // Override existing component options with runtime mixins
        mixins: {
            type: Array,
            default: null,
        },
        localSearchSort: {
            type: Boolean,
            default: false,
        },
        hideDisplayHeaderFilter: {
            type: Boolean,
            default: false,
        },
        printUrl: {
            type: String,
            default: "",
        },
        isForm: {
            type: Boolean,
            default: false,
        },
        isOverview: {
            type: Boolean,
            default: false,
        },
        popupModalNoTitle: {
            type: Boolean,
            default: false,
        },
        rowWarningOptions: {
            type: Object,
            default: function () {
                return {};
            },
        },
        showClearItemButton: {
            type: Boolean,
            default: true,
        },
        showClearItemWhenDisabled: {
            type: Boolean,
            default: true,
        },
        columnPreferenceUrl: {
            type: String,
            default: "",
        },
        datatableUniqueKey: {
            type: String,
            default: null,
        },
        tableId: {
            type: String,
            default: "",
        },
        primaryColor: {
            type: String,
            default: "#3E9DF0",
        },
        isCollapsible: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        draggable,
        DatePicker,
        VueNumeric,
        VueSlider,
    },

    beforeCreate() {
        const mixins = this.$options.propsData.mixins;
        if (mixins) {
            mixins.forEach((mixin) => {
                this.$options = Vue.util.mergeOptions(this.$options, mixin, this);
            });
        }
    },

    data() {
        return {
            // Table header properties
            stickyHeader: true,
            headerChecked: false,
            // Header popup property
            displayHeaderFilters: false,
            showHeader: true,
            // Used for advanced search
            // headerPopupPositionTop: 0,
            // headerPopupPositionLeft: 0,
            // headerPopupPositionLeftDefault: 0,

            // Header sorting property
            allHeadersSelected: true,
            drag: false,
            compactView: true,

            // Table footer properties
            perPage: [20, 50, 100, 200, 300, 400, 500],
            totalRecords: 0,
            pageNumber: "",
            page: 1,
            limit: this.defaultLimit,
            search: {},
            // True when local search hides every row, so the empty state shows instead of a bare header
            localSearchNoResults: false,
            localSearchColumnWidthsLocked: false,
            // sortColumn: {},
            sortColumn: null,
            dir: "desc",

            // Table properties
            defaultColumns: this.columns,
            // Selected records
            selectedRecord: null, // Radio button
            // selectableRowConditions: [],
            // selectablePrefix: null, // Use prop selectRecordPrefix
            // Modified records
            modified: false,
            // addedRecords: [],
            // deletedRecords: [],
            // modifiedRecords: [], // Contains added and edited records
            // Toggle invisibility
            visible: true,

            // Whether can updata by row
            // Use slots for these
            // updateRowButtonText: this.$attrs["update-row-button-text"],
            // updateRowConfirmationButtonText:
            //     this.$attrs["update-row-confirmation-button-text"],

            // Use events for this
            // updateRowUrl: this.$attrs["update-row-url"],

            // advance search property
            // Use slots
            // advanceSearchColumns: this.$attrs["search-product-columns"],
            // advanceSearchProductUrl: this.$attrs["search-product-url"],
            // advanceSearchProductOptionsUrl:
            //     this.$attrs["search-product-options-url"],
            // withoutProductAdvanceSearch:
            //     this.$attrs["without-product-advance-search"],

            // additional data passed by the controller
            // Use computed property
            // miscData: {},
            printShowPopup: false,
            window: window,
            showMenu: false,
            menuPosition: { x: 0, y: 0 },
            selectedRow: null,
            selectedRecordKeys: [],

            // localization
            generalTranslations: window?.bo?.generalTranslations ?? {},
        };
    },

    watch: {
        // for advance search
        selectedRecords(newVal) {
            this.$emit("record-selected", newVal);
        },

        // the pagination footer and the row heights move with the records, so an overview table re-fits
        records: {
            deep: true,
            handler() {
                if (this.isOverview) {
                    this.$nextTick(this.changeTableHeight);
                }
            },
        },
    },

    computed: {
        subrecordSlotColumns() {
            return Object.values(this.subrecordColumns).filter(
                (column) => this.$scopedSlots[`${column.id}_subrecord_column`]
            );
        },

        tableClasses() {
            return {
                "table-container": {
                    "table-responsive": false,
                    dataTables_wrapper: true,
                    "no-footer": true,
                },
                table: {
                    table: false,
                    "table-striped": false,
                    border: false,
                    "has-filter": true,
                    dataTable: true,
                    "no-footer": true,
                    "is-empty": this.showEmptyData,
                },
                "t-head": {},
                "t-body": {},
                "t-head-tr": {},
                "t-body-tr": {},
                td: {},
                th: {},
            };
        },

        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },

        tableTitle() {
            // is any row selected event is used to hide/show elements in header such as create new document button and status dropdown
            // Changes title whenever any row is selected to indicate number of selected documents
            if (this.selectedRecordsCount > 0) {
                return this.selectedRecords.length.toString() + " Selected";
            } else {
                return this.title;
            }
        },

        recordData() {
            return Array.isArray(this.records) ? this.records : this.orderRecords(this.records);
        },

        selectedRecords() {
            let records = [];
            for (const key in this.records) {
                if (this.records[key].checked) {
                    records.push(key);
                }
            }
            return records;
        },

        selectedRecordsCount() {
            return this.selectedRecords.length;
        },

        hasSubrecord() {
            return Object.keys(this.subrecordColumns).length > 0;
            return (
                this.records && this.records.findIndex((element) => typeof element["subrecords"] !== "undefined") !== -1
            );
        },

        isDataLoaded() {
            return this.records != null;
        },

        limitPerPage: {
            get() {
                return this.limit;
            },
            set(newValue) {
                this.limit = newValue;
                this.page = 1;
                this.getData();
            },
        },

        // Use slots
        // attachmentToDownload() {
        //     return (
        //         -1 ===
        //         this.records.findIndex((element) => {
        //             return element.attachment_url != null;
        //         })
        //     );
        // },

        displayActionColumn() {
            // return this.editable && (this.enableDeleteRecord || this.attachmentToDownload);
            return this.editable && (this.deleteSingle || this.deleteMultiple || this.editSingle || this.viewSingle);
        },

        deleteMultiple() {
            return this.enableDeleteRecord || this.enableDeleteMultipleRecords;
        },

        deleteSingle() {
            return this.enableDeleteRecord || this.enableDeleteSingleRecord;
        },

        editSingle() {
            return this.enableEditRecord;
        },

        editSingleInModal() {
            return this.enableEditRecordModal;
        },

        viewSingle() {
            return this.enableViewRecord;
        },

        viewLogSingle() {
            return this.enableViewLogRecord;
        },

        columnSequence: {
            get() {
                return Object.values(this.columns);
            },
            set(newValue) {
                this.saveColumnPreference(newValue); // for sticky column
                this.emitGenericEvent("column_sequence_change", newValue);

                // Handling if the @generic is not defined from parent
                if (!this.$listeners["generic"]) {
                    this.$emit("column_sequence_change", newValue);
                }
            },
        },

        hasVisibleColumns() {
            return this.columnSequence.some((column) => column.visible);
        },

        selectableRecords() {
            if (this.recordSelectable == null) {
                return this.records;
            }

            let temp = {};
            Object.values(this.records)
                .filter((record) => this.isRecordSelectable(record))
                .forEach((record) => {
                    temp[record[this.primaryKey]] = record;
                });

            return temp;
        },

        showEmptyData() {
            return Object.values(this.recordData).length <= 0 || this.localSearchNoResults;
        },

        // Span every header cell (checkbox, visible columns, action, spacer) so the empty state fills the row
        emptyRowColspan() {
            const visibleColumns = Object.values(this.columns).filter(
                (column) => !column.disabled && column.visible
            ).length;

            return (
                visibleColumns +
                (this.selectSingle && !this.selectMultiple ? 1 : 0) +
                (this.selectMultiple && this.hasVisibleColumns && this.hasSelectableRecord ? 1 : 0) +
                (this.displayActionColumn ? 1 : 0) +
                1
            );
        },

        hasSelectableRecord() {
            return this.selectableRecords != null ? Object.keys(this.selectableRecords).length : 0;
        },

        recordsById() {
            return Array.isArray(this.recordData)
                ? this.recordData.reduce((acc, record) => {
                      acc[record.id] = record;
                      return acc;
                  }, {})
                : {};
        },
    },

    mounted() {
        // load columns data
        // No need for this, we specify primary key directly
        // var i = 0;
        // for (var key in this.columns) {
        //     if (this.columns[key].primary_key) {
        //         this.primaryKey = this.columns[key].id;
        //     }
        //     i++;
        // }

        // condition to able select row
        // Specify as prop selectRowConditions
        // if (this.$attrs["selectable-row-condition"]) {
        //     var jsonConditions = JSON.parse(this.$attrs["selectable-row-condition"]);
        //     var tempConditions = [];
        //     var i = 0;
        //     for (var key in jsonConditions) {
        //         tempConditions[i] = jsonConditions[key];
        //         i++;
        //     }
        //     this.selectableRowCondition = tempConditions;
        // }

        // fix popup position incorrect
        // Used for bo advanced search, not part of bo datatable
        // this.$el.querySelector(".bo-table").addEventListener("scroll", this.updatePopupPosition);

        // add prefix if available
        // Use prop selectRecordPrefix
        // if (this.$attrs["selectable-prefix"]) {
        //     this.selectablePrefix = this.$attrs["selectable-prefix"];
        // }

        // Not related to bo datatable
        // if (this.$attrs["import-records-url"]) {
        //     this.importRecordsUrl = this.$attrs["import-records-url"];
        // }

        // Not related to bo datatable
        // if (this.$attrs["download-template-url"]) {
        //     this.downloadTemplateUrl = this.$attrs["download-template-url"];
        // }

        // if (this.records != null) {
        //     this.refreshTable(this.records);
        // } else {
        //     this.$emit("done_loading", null);
        // }
        this.$emit("mounted");
        this.getColumnPreference(this.columns); // for sticky column
        this.$emit("done_loading", this.records);
    },

    methods: {
        ...utils,

        changeTitle(title) {
            this.title = title;
        },

        changeColumns(columns) {
            this.columns = columns;
        },

        emitGenericEvent(eventName, ...args) {
            if (this.$listeners[eventName]) {
                this.$emit(eventName, ...args);
            } else {
                this.$emit("generic", eventName, ...args);
                this.$emit(`after_${eventName}`, ...args);
            }
        },

        // getColumnById(columnId) {
        //     if (Array.isArray(this.columns)) {
        //         return this.columns.filter((column) => column.id == columnId).shift();
        //     }
        //     return null;
        // },

        getData(
            payload = this.getRequestPayload(),
            success = this.defaultGetDataSuccessCallback,
            failure = this.defaultGetDataFailureCallback
        ) {
            this.$emit("get_data", payload, success, failure);
        },

        defaultGetDataSuccessCallback(response) {
            this.refreshTable(response.data);
        },

        defaultGetDataFailureCallback(error) {
            alert("Something went wrong, please try again!");
        },

        resolveURL(rawUrl, index) {
            return this.resolvePlaceholders(rawUrl, this.records[index]);
        },

        resolvePlaceholders(str, record) {
            const array = str.matchAll(/~~(\w*)~~/g);

            for (const group of array) {
                if (group[1] in record) {
                    str = str.replace(new RegExp("~~" + group[1] + "~~", "g"), record[group[1]]);
                }
            }

            return str;
        },

        // updatePopupPosition(event) {
        //     this.headerPopupPositionLeft = this.headerPopupPositionLeftDefault - event.target.scrollLeft;
        //     this.$forceUpdate();
        // },

        setAllHeaders: function () {
            if (true === this.allHeadersSelected) {
                Object.values(this.columns).forEach(function (header) {
                    header.visible = true;
                });
            } else {
                Object.values(this.columns).forEach(function (header) {
                    header.visible = false;
                });
            }
            // sticky columns
            this.saveColumnPreference(this.columnSequence);
        },

        resetHeadersToDefault: function () {
            this.columns = this.defaultColumns;
            this.allHeadersSelected = true;
            this.setAllHeaders();
            this.saveColumnPreference(this.columnSequence); // for sticky column
        },

        promptExternalIfNeeded(prompt, eventName, triggerPrompt = null) {
            // The proper way to solve this would be with function props where the prop
            // would accept an object with event names as the keys and the callbacks as values.
            // But the recommended vue js practice would be to use events.
            if (triggerPrompt == null) {
                this.triggerPrompt = this.modified;
            }
            if (this.externalPrompt && this.$listeners[eventName]) {
                this.$emit(eventName, this.modified, prompt);
            } else {
                this.boPromptIfNeeded(prompt, this.modified, this.confirmationRef);
            }
        },

        changePage(url) {
            const prompt = new Prompt(
                () => {
                    this.page = Number.parseInt(url.split("page=")[1]);
                    this.getData();
                },
                null,
                "Change Page",
                "Changes you made may not be saved. Want to proceed?<br>This action cannot be undone.",
                "Proceed",
                "warning"
            );
            this.promptExternalIfNeeded(prompt, "table_filter_prompt");
        },

        goToPage: function () {
            //Refactor pageNumber to use computed
            if ("" != this.pageNumber) {
                const prompt = new Prompt(
                    () => {
                        this.page = this.parsePageNumber(this.pageNumber);
                        this.getData();
                    },
                    null,
                    "Change Page",
                    "Changes you made may not be saved. Want to proceed?<br>This action cannot be undone.",
                    "Proceed",
                    "warning"
                );
                this.promptExternalIfNeeded(prompt, "table_filter_prompt");
            }
        },

        parsePageNumber: function (pageNumber) {
            return Math.min(Math.max(Number.parseInt(this.pageNumber), 1), this.pagination.last_page);
        },

        // showLoading()/hideLoading() come from the http mixin (#111741: coordinated page veil)

        refreshTable: function (tableData) {
            this.resetColumnStates();
            // this.records = tableData.data["records"];
            // this.miscData = tableData.data["extra"];
            // this.pagination = tableData.meta;

            // this.columns.forEach((column) => {
            //     //Dont use search config with this config
            //     if (column.reset_after_search) {
            //         column.search = "";
            //     }
            // });

            // if (this.pagination) {
            //     this.$emit("updateProductTotal", this.pagination.total);
            // }

            // update checkbox
            // if (this.selectMultiple) {
            //     this.records.forEach((record) => {
            //         record.checked = false;
            //         var recordId = this.getKeyWithSelectedPrefixIfNeeded(record[this.primaryKey]);
            //         var exists = this.selectedRecords.some(function (field) {
            //             return field === recordId;
            //         });
            //         if (exists) {
            //             record.checked = true;
            //         }
            //     });
            // }

            // if (tableData.data["dataHeaders"]) {
            //     for (var id in tableData.data["dataHeaders"]) {
            //         var option = tableData.data["dataHeaders"][id];
            //         let column = this.columns.find((p) => p.id == id);
            //         if (column) {
            //             if ("select" == column.type || "status" == column.type) {
            //                 column.options = option;
            //                 if (!column.options.find((p) => p.id == column.search)) {
            //                     column.search = "";
            //                 }
            //             } else if (
            //                 ("number" == column.type || "currency" == column.type) &&
            //                 "undefined" == typeof column.meta.min
            //             ) {
            //                 column.showPopup = false;
            //                 column.meta.min = option.range[0];
            //                 column.meta.max = option.range[1];
            //                 if (!column.meta.value[0] && !column.meta.value[1]) {
            //                     column.meta.value = [option.range[0], option.range[1]];
            //                 }
            //                 column.meta.enableCross = true;
            //             } else if ("product" == column.type) {
            //                 column.showPopup = false;
            //             }
            //         }
            //     }
            // }
            // this.$forceUpdate();
            this.$emit("done_loading", tableData);
        },

        // Not used anywhere
        // updateSearchWithAddParameter(array) {
        //     var searchString = "";

        //     this.columns.forEach((column) => {
        //         searchString += column.id + "~~~" + column.search + "___";
        //     });
        //     array.forEach((object) => {
        //         searchString += object.key + "~~~" + object.value + "___";
        //     });

        //     this.search = searchString;

        //     this.getData();
        // },

        getRequestPayload() {
            // Merge search filters into payload
            let params = {
                ...{
                    page: this.page,
                    limit: this.limit,
                    column: this.column,
                },
                ...this.search,
            };

            if (this.sortColumn) params[`sort[${this.sortColumn}]`] = this.dir;

            return {
                params: params,
                headers: this.headers,
            };
        },

        // Format: id=search
        updateSearch: function (column) {
            if (this.localSearchSort) {
                if (column.search) {
                    this.search[column.id] = column.search;
                } else {
                    delete this.search[column.id];
                }

                this.updateLocalSearchSort(column);
            } else {
                if (column.search) {
                    this.search[column.id] = column.search;
                    this.page = 1;
                } else delete this.search[column.id];

                const prompt = new Prompt(
                    () => {
                        this.getData();
                    },
                    () => {
                        var search_array = this.search.split("___");
                        var searches = [];
                        search_array.forEach((search) => {
                            var s = search.split("~~~");
                            searches[s[0]] = s[1];
                        });
                        this.columns.forEach((column) => {
                            column.search = searches[column.id];
                        });
                    },
                    "Change Page",
                    "Changes you made may not be saved. Want to proceed?<br>This action cannot be undone.",
                    "Proceed",
                    "warning"
                );
                this.promptExternalIfNeeded(prompt, "table_filter_prompt");
            }
        },

        updateDateSearch(column) {
            if (this.localSearchSort) {
                if (column.search && column.search[0] && column.search[1]) {
                    this.search[column.id] = [column.search[0], column.search[1]];
                } else {
                    delete this.search[column.id];
                }
                this.updateLocalSearchSort(column);
            } else {
                if (column.search) {
                    this.search[`${column.id}_min`] = column.search[0];
                    this.search[`${column.id}_max`] = column.search[1];
                    this.page = 1;
                } else delete this.search[column.id];

                const prompt = new Prompt(
                    () => {
                        this.getData();
                    },
                    null,
                    "Change Page",
                    "Changes you made may not be saved. Want to proceed?<br>This action cannot be undone.",
                    "Proceed",
                    "warning"
                );
                this.promptExternalIfNeeded(prompt, "table_filter_prompt");
            }
        },

        // Force data table to send two parameters of the column id with min and max appended
        updateRangeSearch(column, inclusive = false) {
            if (column.search) {
                this.search[`${column.id}${inclusive ? "_min" : "_start"}`] = column.search[0];
                this.search[`${column.id}${inclusive ? "_max" : "_end"}`] = column.search[1];
                this.page = 1;
            } else delete this.search[column.id];

            const prompt = new Prompt(
                () => {
                    this.getData();
                },
                null,
                "Change Page",
                "Changes you made may not be saved. Want to proceed?<br>This action cannot be undone.",
                "Proceed",
                "warning"
            );
            this.promptExternalIfNeeded(prompt, "table_filter_prompt");
        },

        // Datatable Sorting
        sort(column) {
            if (true == column.orderable) {
                if (this.localSearchSort) {
                    if (this.sortColumn != column.id) {
                        this.sortColumn = column.id;
                        this.dir = "desc";
                    } else {
                        this.dir = this.dir == "asc" ? "desc" : "asc";
                    }
                    this.updateLocalSearchSort(column);
                } else {
                    if (this.sortColumn != column.id) {
                        this.sortColumn = column.id;
                        this.dir = "desc";
                    } else {
                        this.dir = this.dir == "asc" ? "desc" : "asc";
                    }

                    this.page = 1;
                    this.getData();
                }
            }
        },

        updateLocalSearchSort(column) {
            let table = this.$el;
            let rows = table.querySelectorAll("tbody tr:not(.bo-empty-data)");
            let hasVisibleRow = false;

            // Lock column widths while every row is still shown, so hiding rows can't shrink the columns
            // (and the header search inputs sized to them)
            if (!this.localSearchColumnWidthsLocked) {
                table.querySelectorAll("table > thead > tr:last-child > th:not(:last-child)").forEach((th) => {
                    const style = getComputedStyle(th);
                    const width =
                        style.boxSizing === "border-box"
                            ? th.getBoundingClientRect().width
                            : parseFloat(style.width);
                    // width too, not just min-width: otherwise the empty-state row can still spread spare width
                    // onto these columns instead of the spacer
                    th.style.width = th.style.minWidth = `${width}px`;
                });
                this.localSearchColumnWidthsLocked = true;
            }

            for (const row of rows) {
                if (Object.values(this.search).length > 0) {
                    let check = true;
                    for (const [columnId, searchValue] of Object.entries(this.search)) {
                        if (searchValue instanceof Array) {
                            // Currently using isNaN to check whether the data provided is date or num
                            // Treat it as if it is not number, then it is date
                            if (isNaN(searchValue[0])) {
                                if (!this.localDateSearch(columnId, searchValue, row, column)) {
                                    check = false;
                                    break;
                                }
                            } else {
                                if (!this.localNumberRangeSearch(columnId, searchValue, row, column)) {
                                    check = false;
                                    break;
                                }
                            }
                        } else {
                            if (!this.localSearch(columnId, searchValue, row, column)) {
                                check = false;
                                break;
                            }
                        }
                    }
                    if (check) {
                        row.style.display = "table-row";
                        hasVisibleRow = true;
                    } else {
                        row.style.display = "none";
                    }
                } else {
                    row.style.display = "table-row";
                    hasVisibleRow = true;
                }
            }

            this.localSearchNoResults = rows.length > 0 && !hasVisibleRow;

            this.localSort();
        },

        localSearch(columnId, searchValue, row, column) {
            let content = this.getContentFromHTML(row, columnId);
            content = content.replace(/[_-]/g, " ");
            searchValue = searchValue.replace(/[_-]/g, " ");

            if (column.type == "text") {
                return content.toLowerCase().includes(searchValue.toLowerCase());
            } else if (column.type == "select") {
                return content.toLowerCase() === searchValue.toLowerCase();
            }
        },

        localDateSearch(columnId, searchValue, row, column) {
            let content = row.querySelector("tr td." + (columnId + "").replace("_", "-") + " span").innerHTML;
            let minDate = new Date(searchValue[0]);
            let maxDate = new Date(searchValue[1]);
            let searchDate = new Date(content);
            return searchDate >= minDate && searchDate <= maxDate;
        },

        localNumberRangeSearch(columnId, searchValue, row, column) {
            let content = this.getContentFromHTML(row, columnId);

            // In case there is comma in the number
            content = parseFloat(content.replace(/,/g, ""));

            let minNum = searchValue[0];
            let maxNum = searchValue[1];
            if (typeof maxNum == "undefined") {
                return content >= minNum;
            } else {
                return content >= minNum && content <= maxNum;
            }
        },

        localSort() {
            if (!this.sortColumn) {
                return;
            }

            let table = this.$el;
            let switching = true;
            let rows, i, a, b, shouldSort;

            while (switching) {
                switching = false;

                rows = table.querySelectorAll("tbody tr:not(.bo-empty-data)");

                for (i = 0; i < rows.length; i++) {
                    if (rows[i + 1]) {
                        a = rows[i].querySelector("td." + (this.sortColumn + "").replace("_", "-"));
                        b = rows[i + 1].querySelector("td." + (this.sortColumn + "").replace("_", "-"));

                        let firstNum = a.querySelector("span")?.innerHTML.replace(",", "");
                        let secondNum = b.querySelector("span")?.innerHTML.replace(",", "");

                        let firstDate = Date.parse(firstNum?.replace(" ", ""));
                        let secondDate = Date.parse(secondNum?.replace(" ", ""));

                        if (!isNaN(firstNum) && !isNaN(secondNum)) {
                            if (
                                (this.dir == "asc" && parseFloat(firstNum) > parseFloat(secondNum)) ||
                                (this.dir == "desc" && parseFloat(firstNum) < parseFloat(secondNum))
                            ) {
                                shouldSort = true;
                                break;
                            }
                        } else if (!isNaN(firstDate) && !isNaN(secondDate)) {
                            if (
                                (this.dir == "asc" && firstDate > secondDate) ||
                                (this.dir == "desc" && firstDate < secondDate)
                            ) {
                                shouldSort = true;
                                break;
                            }
                        } else if (
                            (this.dir == "asc" && a.innerHTML.toLowerCase() > b.innerHTML.toLowerCase()) ||
                            (this.dir == "desc" && a.innerHTML.toLowerCase() < b.innerHTML.toLowerCase())
                        ) {
                            shouldSort = true;
                            break;
                        }
                    }
                }

                if (rows[i + 1] && shouldSort) {
                    rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                    switching = true;
                }
            }
        },

        getContentFromHTML(row, columnId) {
            let content = "";

            if (row.querySelector("tr td." + (columnId + "").replace("_", "-") + " span") !== null) {
                content = row.querySelector("tr td." + (columnId + "").replace("_", "-") + " span").innerHTML;
            } else if (row.querySelector("tr td." + (columnId + "").replace("_", "-") + " input") !== null) {
                content = row.querySelector("tr td." + (columnId + "").replace("_", "-") + " input").value;
            } else if (row.querySelector("tr td." + (columnId + "").replace("_", "-") + " a") !== null) {
                content = row.querySelector("tr td." + (columnId + "").replace("_", "-") + " a").innerHTML;
            }
            return content;
        },

        changePopupVisibility(event, column) {
            Object.keys(this.columns).forEach((key) => {
                this.columns[key].showPopup = false;
            });

            var elem_position = event.target.getBoundingClientRect();
            var bo_table_position = event.target.closest(".bo-table-div").getBoundingClientRect();

            if (event.target.closest(".modal-body")) {
                var modalOffset = event.target.closest(".modal-body").getBoundingClientRect();
                this.headerPopupPositionTop = window.pageYOffset + elem_position.top - modalOffset.top + 40;
                this.headerPopupPositionLeft = elem_position.left - modalOffset.left;
            } else {
                // main table
                this.headerPopupPositionTop = elem_position.top - bo_table_position.top + elem_position.height + 30;
                this.headerPopupPositionLeft = elem_position.left - bo_table_position.left + 30;
            }
            this.headerPopupPositionLeftDefault =
                this.headerPopupPositionLeft + this.$el.querySelector(".bo-table").scrollLeft;

            column.showPopup = true;
            this.$forceUpdate();
        },

        formattedTotal(total) {
            if (total) {
                return parseFloat(total)
                    .toFixed(0)
                    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
            } else {
                return 0;
            }
        },

        changeTableVisibility() {
            this.visible = !this.visible;
        },

        changeCompactView() {
            this.compactView = !this.compactView;
        },

        toggleHeaderFiltersVisibility() {
            this.displayHeaderFilters = !this.displayHeaderFilters;
        },

        hideHeaderFilters(event) {
            this.displayHeaderFilters = false;
        },

        // Should be a slot
        // exportRecords(type) {
        //     var searchString = "";
        //     var columnNames = "";

        //     this.columns.forEach((column) => {
        //         searchString += column.id + "~~~" + column.search + "___";
        //         columnNames += column.id + "~~~" + column.label + "___";
        //     });

        //     var selectedRecords = [];
        //     if ("all" != type) {
        //         if (0 == this.selectedRecords.length) {
        //             alert("Kindly select at least one records before export.", "Export Records");
        //             return;
        //         }
        //         selectedRecords = this.selectedRecords;
        //     }

        //     if (this.beforeExport && this.beforeExport(type, this) === false) {
        //         return false;
        //     }

        //     this.showLoading();
        //     axios({
        //         url: this.exportUrl,
        //         method: "GET",
        //         responseType: "blob",
        //         params: {
        //             search: searchString,
        //             columnNames: columnNames,
        //             selectedRecords: selectedRecords,
        //             page: this.page,
        //             limit: this.limit,
        //         },
        //     })
        //         .then((response) => {
        //             var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        //             var fileLink = document.createElement("a");

        //             fileLink.href = fileURL;
        //             fileLink.setAttribute("download", this.title + moment().format("_YYYY-MM-DD-HH-mm-ss") + ".xlsx");
        //             document.body.appendChild(fileLink);

        //             fileLink.click();
        //         })
        //         .catch((err) => {
        //             alert("Unable to export Data now.");
        //         })
        //         .then(() => {
        //             document.body.classList.remove("loading");
        //         });
        // },

        // EXCLUSIVE TO documents module only. vuex store is needed to use, called from all_document.js -> updateStatusInBulkEventHandler()
        // updateStatusInBulk() {
        //     this.showLoading();
        //     var url = document.getElementsByName("url")[0].getAttribute("content"); // for example: http://127.0.0.1:8000/test
        //     axios
        //         .post(url + "/documents/history/payment/updateStatus", {
        //             status: this.$store.state.status,
        //             document_ids: this.selectedRecords,
        //         })
        //         .then((response) => {
        //             this.headerChecked = false;
        //             this.selectedRecords = [];
        //             this.selectedRecordsCount = 0;
        //             this.getData();
        //             // loading screen will hide at refreshTable method
        //         })
        //         .catch(function (error) {
        //             console.log(error);
        //             alert("Unable to update status now.");
        //             document.body.classList.remove("loading");
        //         });
        // },

        modifyRecord(eventName, key, columnKey, record) {
            // this.modified = true;
            this.$emit("modify", key, columnKey, record);
            this.$emit(eventName, key, columnKey, record);
        },

        editRecordHandler(key, record, column) {
            this.modifyRecord(`${column.type}_change_${column.id}`, key, column.id, record);
        },

        editRecordFn(key, column) {
            return (event) => {
                this.editRecordHandler(key, event, column);
            };
        },

        //Recommended to intercept this event and change the callback function
        updatedSelectedRecords() {
            let label = this.selectedRecords.join("\n");
            const prompt = new Prompt(
                () => {
                    this.getData();
                    this.modified = false;
                },
                null,
                "Update Records",
                "Are you sure you want to update the following records? This action cannot be undone.<br>" + label,
                "Update",
                "info"
            );
            this.promptExternalIfNeeded(prompt, "update_records_prompt", true);
        },

        //Recommended to intercept this event and change the callback function
        deleteSelectedRecords() {
            let label = this.selectedRecords.join("\n");
            const prompt = new Prompt(
                () => {
                    this.emitGenericEvent("delete_multiple", this.selectedRecords, () => {
                        this.getData();
                        this.modified = false;
                    });
                },
                null,
                "Delete Records",
                "Are you sure you want to delete the following records? This action cannot be undone.<br>" + label,
                "Delete",
                "warning"
            );
            this.promptExternalIfNeeded(prompt, "delete_records_prompt", true);
            this.showMenu = false;
        },

        //Recommended to intercept this event and change the callback function
        deleteRecord(recordKey) {
            const prompt = new Prompt(
                () => {
                    this.emitGenericEvent("delete", recordKey, () => {
                        this.getData();
                        this.modified = false;
                    });
                    this.emitGenericEvent("delete_multiple", [recordKey], () => {
                        this.getData();
                        this.modified = false;
                    }); // For those too lazy to handle two separate events
                },
                null,
                "Delete Record",
                "Are you sure you want to delete the following record? This action cannot be undone.<br><b>" +
                    recordKey +
                    "</b>",
                "Delete",
                "warning"
            );
            this.promptExternalIfNeeded(prompt, "delete_record_prompt", true);
            this.showMenu = false;
        },

        goToUrl(id) {
            if (window.location.href.lastIndexOf("/") === window.location.href.length - 1) {
                window.location.assign(`${window.location.href}${id}`);
            } else {
                window.location.assign(`${window.location.href}/${id}`);
            }
        },

        goToLogUrl(id) {
            if (window.location.href.lastIndexOf("/") === window.location.href.length - 1) {
                window.location.assign(`${window.location.href}${id}/records`);
            } else {
                window.location.assign(`${window.location.href}/${id}/records`);
            }
        },

        orderRecords(records) {
            let ordered = [];

            for (const id in records) {
                if (records[id].order == null) {
                    return records;
                }

                ordered[records[id].order] = records[id];
            }

            ordered = ordered.filter((item) => item != null); // Remove holes in array
            return ordered;
        },

        checkAllRecords(event) {
            const isChecked = event?.target ? event.target.checked : this.headerChecked;
            this.headerChecked = isChecked;
            if (isChecked) {
                this.selectAllRecords();
            } else {
                this.clearSelection();
            }
            this.$forceUpdate();
        },

        selectAllRecords() {
            this.selectedRecordKeys = [];

            for (const [recordKey, record] of Object.entries(this.records)) {
                const isSelectable =
                    this.selectableRecords == null ||
                    this.selectableRecords[recordKey] != null ||
                    (record && this.selectableRecords[record[this.primaryKey]] != null) ||
                    (this.recordSelectable == null ? true : this.recordSelectable(record));

                if (!isSelectable) continue;

                const primaryKeyValue = record && record[this.primaryKey] != null ? record[this.primaryKey] : recordKey;

                if (!this.selectedRecordKeys.includes(primaryKeyValue)) {
                    this.selectedRecordKeys.push(primaryKeyValue);
                }

                if (record) {
                    this.$set(record, "checked", true);
                }
                this.emitGenericEvent("select_multiple_records", recordKey, true);
                if (primaryKeyValue !== recordKey) {
                    this.emitGenericEvent("select_multiple_records", primaryKeyValue, true);
                }
            }

            this.emitGenericEvent("selected_multiple_records", this.selectedRecords.slice(), this.primaryKey);
        },

        clearSelection() {
            this.selectedRecordKeys = [];

            for (const [recordKey, record] of Object.entries(this.records)) {
                const primaryKeyValue = record && record[this.primaryKey] != null ? record[this.primaryKey] : recordKey;

                if (record) {
                    this.$set(record, "checked", false);
                }
                this.emitGenericEvent("select_multiple_records", recordKey, false);
                if (primaryKeyValue !== recordKey) {
                    this.emitGenericEvent("select_multiple_records", primaryKeyValue, false);
                }
            }

            this.emitGenericEvent("unselected_multiple_records", this.selectedRecords.slice(), this.primaryKey);
        },

        // Should be a add products advance search component
        // advanceSearch(product) {
        //     if ("" == product) {
        //         return;
        //     }
        //     var searchString = "advance_search~~~1___products~~~" + product;

        //     if (this.modified) {
        //         this.$refs.confirmation
        //             .activate(
        //                 "Change Page",
        //                 "Changes you made may not be saved. Want to proceed?<br>This action cannot be undone.",
        //                 "Proceed",
        //                 "warning"
        //             )
        //             .then((confirm) => {
        //                 if (confirm) {
        //                     this.search = searchString;

        //                     this.getData();
        //                 } else {
        //                     if ("" == this.search) {
        //                         this.columns.forEach((column) => {
        //                             column.search = "";
        //                         });
        //                     } else {
        //                         var search_array = this.search.split("___");
        //                         var searches = [];
        //                         search_array.forEach((search) => {
        //                             var s = search.split("~~~");
        //                             searches[s[0]] = s[1];
        //                         });
        //                         this.columns.forEach((column) => {
        //                             column.search = searches[column.id];
        //                         });
        //                     }
        //                     return false;
        //                 }
        //             });
        //     } else {
        //         this.search = searchString;

        //         this.getData();
        //     }
        // },

        // Should be a add products component
        // addProducts(products) {
        //     var searchString = "advance_search~~~1___products~~~" + products.join(",");
        //     var self = this;

        //     axios
        //         .get(this.getRecordsUrl, {
        //             params: {
        //                 search: searchString,
        //                 dir: "asc",
        //                 column: this.primaryKey,
        //                 length: products.length,
        //                 page: 1,
        //             },
        //         })
        //         .then((response) => {
        //             response.data.data.forEach(function (record) {
        //                 var addIndex = self.records.findIndex(
        //                     (item) => item[self.primaryKey] === record[self.primaryKey]
        //                 );
        //                 if (-1 === addIndex) {
        //                     var index = self.records.length;
        //                     self.records[index] = record;

        //                     self.addedRecords.push(record[self.primaryKey]);
        //                     self.modified = true;
        //                 }
        //             });

        //             this.$forceUpdate();
        //         })
        //         .catch(function (error) {
        //             alert("Unable to add products now.");
        //         })
        //         .then(function () {
        //             document.body.classList.remove("loading");
        //         });
        // },

        //Should be a slot
        // downloadAttachment(record) {
        //     if (record && record.attachment_url) {
        //         window.open(record.attachment_url, "_blank").focus();
        //     }
        // },

        beforeWindowUnload(e) {
            e.returnValue = "";
        },

        // preparePayload(additionalData) {
        //     let addRecords = [];
        //     let updateRecords = [];
        //     this.records.forEach((record) => {
        //         if (this.addedRecords.includes(record[this.primaryKey])) {
        //             addRecords.push(record);
        //         }
        //         if (this.modifiedRecords.includes(record[this.primaryKey])) {
        //             updateRecords.push(record);
        //         }
        //     });

        //     let payload = {};
        //     payload["delete"] = this.deletedRecords;
        //     payload["add"] = addRecords;
        //     payload["update"] = updateRecords;
        //     payload["records"] = this.records;

        //     if (additionalData != null) {
        //         payload["misc"] = additionalData;
        //     }

        //     return payload;
        // },

        // updateRecords(additionalData) {
        //     const prompt = new Prompt(
        //         function () {
        //             this.getData();
        //         },
        // null,
        //         "Update",
        //         "Are you sure want to update all the records?<br>This action cannot be undone.",
        //         "Update",
        //         "info"
        //     );
        //     this.promptExternalIfNeeded(prompt, "update_all_records_prompt");
        // },

        // resetModifiedState() {
        //     this.modifiedRecords = [];
        //     this.modified = false;
        // },

        resetColumnSearchStateAfterSearch(column) {
            if (column.resetAfterSearch) {
                column.search = "";
            }
        },

        resetColumnStates() {
            for (let column of Object.values(this.columns)) {
                this.resetColumnSearchStateAfterSearch(column);
            }
        },

        checkSelectableRowCondition(record) {
            return true;
        },

        changeSubRecordVisibility(record) {
            record.subrecordVisibility = !record.subrecordVisibility;
        },

        // hideExportPopup() {
        //     this.exportShowPopup = false;
        // },

        // addRow(row) {
        //     this.records.push(row);
        //     this.addedRecords.push(row[this.primaryKey]);
        //     this.modifiedRecords.push(row[this.primaryKey]);
        //     this.modified = true;
        // },

        // Not related to bo datatable
        // downloadTemplate() {
        //     this.showLoading();
        //     axios({
        //         url: this.downloadTemplateUrl,
        //         method: "GET",
        //         responseType: "blob",
        //     })
        //         .then((response) => {
        //             var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        //             var fileLink = document.createElement("a");

        //             fileLink.href = fileURL;
        //             fileLink.setAttribute("download", this.title + " Template.xlsx");
        //             document.body.appendChild(fileLink);

        //             fileLink.click();
        //         })
        //         .catch((err) => {
        //             alert("Unable to download template now.");
        //         })
        //         .then(() => {
        //             document.body.classList.remove("loading");
        //         });
        // },

        // Not related tp bo datatable
        // importRecords(event) {
        //     if (event.target.files.length) {
        //         if (
        //             event.target.files[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        //             event.target.files[0].type == "application/vnd.ms-excel"
        //         ) {
        //             const formData = new FormData();
        //             formData.append("file", event.target.files[0], event.target.files[0].name);
        //             this.showLoading();
        //             var self = this;
        //             axios
        //                 .post(this.importRecordsUrl, formData)
        //                 .then((response) => {
        //                     self.getData();
        //                     alert(response.data.message, "Success", "success");
        //                 })
        //                 .catch((error) => {
        //                     if (error.response) {
        //                         // Request made and server responded
        //                         alert(error.response.data.error, error.response.data.title);
        //                     } else if (error.request) {
        //                         // The request was made but no response was received
        //                         alert("Unable to import records now.");
        //                     } else {
        //                         // Something happened in setting up the request that triggered an Error
        //                         alert("Unable to import records now.");
        //                     }
        //                 })
        //                 .then(() => {
        //                     this.hideLoading(); // #111741: coordinated page veil
        //                 });
        //         } else {
        //             alert("Invalid file format, Kindly use only <b>.xlsx</b> format");
        //         }
        //     }
        // },

        // hidePopup(column) {
        //     column.showPopup = false;
        //     this.$forceUpdate();
        // },

        getKeyWithSelectedPrefixIfNeeded(key) {
            if (this.selectablePrefix != null) {
                return this.selectablePrefix + key;
            }

            return key;
        },

        selectSingleHandler(event, recordKey) {
            if (event.target.classList.contains("dropdown-trigger")) {
                return;
            }
            this.emitGenericEvent("selected_single_record", recordKey);
            this.selectedRecordKeys = [recordKey];

            // inject method from bo-popup-modal
            this.triggerPopupModalAction();
        },

        isSelected(recordKey) {
            return this.selectedRecordKeys.includes(recordKey);
        },

        selectMultipleHandler(event, recordKey) {
            if (event.target.classList.contains("dropdown-trigger")) {
                return;
            }
            let blackLists = ["SELECT", "INPUT", "A"];
            let excludeBlackListsInputType = ["checkbox", "radio", "file"];
            let includeBlackListsClass = ["max-num"];
            if (blackLists.includes(event.target.tagName) && !excludeBlackListsInputType.includes(event.target.type)) {
                return;
            }
            const index = this.selectedRecordKeys.indexOf(recordKey);

            if (index === -1) {
                this.selectedRecordKeys.push(recordKey);
            } else {
                this.selectedRecordKeys.splice(index, 1);
            }

            const record = this.records[recordKey] || (Array.isArray(this.records) && this.records.find((r) => r[this.primaryKey] == recordKey));
            if (record) {
                this.$set(record, "checked", this.selectedRecordKeys.includes(recordKey));
            }

            this.emitGenericEvent("select_multiple_records", recordKey);
            this.emitGenericEvent("selected_multiple_records", this.selectedRecords.slice());
        },

        subrecordChangeHandler(key, subrecordKey, subrecord, columnType) {
            this.records[key].subrecords[subrecordKey] = subrecord;
            this.modifyRecord(key);

            this.$emit(`subrecord_${columnType}_change`, key, subrecordKey, subrecord);
        },

        subrecordDeleteHandler(key, subrecordKey, subrecord) {
            const prompt = new Prompt(
                () => {
                    this.$emit("delete_subrecord", key, subrecordKey);
                    this.getData();
                    this.modified = false;
                },
                null,
                "Delete Record",
                "Are you sure you want to delete the following record? This action cannot be undone." + subrecordKey,
                "Delete",
                "warning"
            );
            this.promptExternalIfNeeded(prompt, "delete_record_prompt", true);
        },
        //workaround old template compiler
        getColumnMax(column, record) {
            return column.max ?? record[column.maxId] ?? null;
        },
        isRecordEditable(record, column) {
            if (!this.editable) {
                return false;
            }

            if (!column.editable) {
                return false;
            }

            if (this.recordEditable != null) {
                return this.recordEditable.call(this, record, column);
            }

            return true;
        },
        isRecordSelectable(record) {
            if (this.recordSelectable != null) {
                return this.recordSelectable.call(this, record);
            }

            return true;
        },
        isRecordDeletable(record) {
            if (!record) return false;

            if (this.recordDeletable != null) {
                return this.recordDeletable.call(this, record);
            }

            return true;
        },
        printRecords(type) {
            if (0 == this.selectedRecords) {
                alert("Kindly select at least one record before print.", "Print Records");
                return;
            }

            this.showLoading();
            axios({
                url: this.printUrl,
                method: "GET",
                responseType: "blob",
                params: {
                    selectedRowIds: this.selectedRecords,
                    type: type,
                },
            })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", this.title + moment().format("_YYYY-MM-DD-HH-mm-ss") + ".pdf");
                    document.body.appendChild(fileLink);

                    fileLink.click();
                })
                .catch((err) => {
                    alert("Unable to export Data now.");
                })
                .then(() => {
                    this.hideLoading(); // #111741: coordinated page veil
                });
        },
        hidePrintPopup() {
            this.printShowPopup = false;
        },
        showContextMenu(event, row, tableId) {
            console.log(event.target.tagName);
            if (event.target.tagName != "IMG") {
                let tagNames = ["A", "IMG", "I"];
                // Ignore for links, images and icons
                if (!tagNames.includes(event.target.tagName)) {
                    event.preventDefault();

                    this.selectedRow = row;
                    this.showMenu = true;

                    const uniqueTableRef = "datatable_" + tableId;

                    const tableComponent = this.$refs[uniqueTableRef];
                    console.log(tableComponent);

                    if (tableComponent && tableComponent.$el) {
                        // Access the root DOM element of the component
                        const tableElement = tableComponent.$el;
                        // Get the offset of the table
                        const tableOffset = tableElement.getBoundingClientRect();

                        // Calculate the position relative to the table
                        const offsetX = event.pageX - tableOffset.left + 10;
                        const offsetYRelativeToTable = event.clientY - tableOffset.top + 140;
                        this.menuPosition.x = offsetX;
                        this.menuPosition.y = offsetYRelativeToTable;
                    }

                    document.addEventListener("click", this.closeContextMenu);
                }
            }
        },

        closeContextMenu(event) {
            const isOutsideMenu = !event.target.closest(".custom-menu");

            if (isOutsideMenu) {
                this.showMenu = false;
                document.removeEventListener("click", this.closeContextMenu);
            }
        },

        updateWidth(e) {
            var width = (e.target.value.length + 1) * 10;
            const tableInput = this.$refs.tableInput;
            e.target.style.width = width + "px";
        },

        // Sticky column - save column preference to db
        saveColumnPreference(columnSequence) {
            if (!Boolean(this.columnPreferenceUrl) || !Boolean(this.datatableUniqueKey)) return;

            // from columnSequence, saving only the id and visible property
            const columnIdVisibilityData = columnSequence.map((column) => {
                return {
                    id: column.id,
                    visible: column.visible,
                };
            });
            const payload = {
                datatable_key: this.datatableUniqueKey,
                column_sequence: columnIdVisibilityData,
            };

            this.saveColumnPreferenceData(
                this.columnPreferenceUrl,
                payload,
                (response) => {
                    // console.log("Request succeeded:", response);
                },
                (error) => {
                    // console.log("Request failed:", error);
                }
            );
        },

        // Sticky column - get column preference from db
        getColumnPreference(existingColumns) {
            if (!Boolean(this.columnPreferenceUrl) || !Boolean(this.datatableUniqueKey)) return;
            const url = this.columnPreferenceUrl + "/" + 1; // 1 is dummy id, just to call the get route
            const payload = {
                datatable_key: this.datatableUniqueKey,
            };
            const params = new URLSearchParams(payload);
            const queryString = "?" + params.toString();

            this.getColumnPreferenceData(
                url + queryString,
                (response) => {
                    if (response.data && response.data.column_preference) {
                        const columnPreference = JSON.parse(response.data.column_preference);

                        // re-arranging the columns based on the column preference's sequence
                        const temp = [];
                        Object.values(columnPreference).forEach((dbColumn) => {
                            const column = this.columnSequence.find((localColumn) => localColumn.id == dbColumn.id);
                            if (column) {
                                // change the visibility of the column
                                column.visible = dbColumn.visible;
                                temp.push(column);
                            }
                        });

                        // Handling extra columns in the this.columnSequence array
                        if (temp.length < this.columnSequence.length) {
                            const extraColumns = this.columnSequence.filter(
                                (localColumn) => !temp.find((column) => column.id == localColumn.id)
                            );
                            temp.push(...extraColumns);
                        }

                        this.$set(this, "columnSequence", temp);
                    }
                },
                (error) => {
                    // console.log("Request failed:", error);
                }
            );
        },

        changeSubrecordColumnHeaderVisibility(header) {
            Object.values(this.subrecordColumns).forEach((subrecordColumn) => {
                if (header.id == subrecordColumn.id) {
                    subrecordColumn.visible = header.visible;
                }
            });
        },

        subrecordClass(record) {
            if (this.hasSubrecord) {
                const keys = Object.values(this.recordData).map((record) => record[this.primaryKey]);
                const index = keys.indexOf(record[this.primaryKey]);

                if (index === -1) {
                    return "";
                }

                const position = index + 1;
                if (position % 2 === 0) {
                    return "even";
                } else {
                    return "odd";
                }
            }
            return "";
        },
    },

    updated() {
        const tableInput = this.$refs.tableInput;
        if (tableInput) {
            var maxWidth = 0;

            tableInput.forEach((tableInput) => {
                const inputValue = tableInput.value;
                const width = (inputValue.length + 1) * 10;
                if (!(width < 100)) {
                    if (width > maxWidth) {
                        maxWidth = width;
                    }
                }
            });

            tableInput.forEach((tableInput) => {
                tableInput.style.width = maxWidth + "px";
            });
        }
    },
};
</script>
